module.exports = __webpack_public_path__ + "img/mynewsimg3.c2edf612.png";